import React, { Component } from 'react'

import PropTypes from 'prop-types'

import { capitalize } from '../../../../utils/string'
import { fractionToPercent, roundTo100sPlace } from '../../../../utils/data'

class CustomPieZoomChart extends Component {
  static propTypes = {
    chartData: PropTypes.any,
    image: PropTypes.any,
    sliceColors: PropTypes.array,
    height: PropTypes.number,
    onHover: PropTypes.func,
    innerRadius: PropTypes.number,
    legend: PropTypes.bool,
    labels: PropTypes.bool,
    shouldUpdateData: PropTypes.bool,
    outerMargin: PropTypes.number,
    elementId: PropTypes.string.isRequired,
    isInteger: PropTypes.bool,
  }
  static defaultProps = {
    //regular, lighter, darker (then repeat)
    sliceColors: [
      '#30BC9D',
      '#FF9552',
      '#5099DE',
      '#EE6352',
      '#68CEB7',
      '#FFA871',
      '#7FB4E7',
      '#F28D81',
      '#338472',
      '#D17A44',
      '#33628E',
      '#A04438',

      '#30BC9D',
      '#FF9552',
      '#5099DE',
      '#EE6352',
      '#68CEB7',
      '#FFA871',
      '#7FB4E7',
      '#F28D81',
      '#338472',
      '#D17A44',
      '#33628E',
      '#A04438',
    ],
    height: 500,
    innerRadius: 0.7,
    legend: false,
    labels: true,
    shouldUpdateData: true,
    isInteger: false,
  }

  constructor(props) {
    super(props)

    this._isMounted = false

    this.formatData = slice => {
      const { isInteger } = this.props
      if (isInteger) {
        return roundTo100sPlace(slice.data.value)
      } else {
        return fractionToPercent(slice.data.fraction)
      }
    }

    this.constructChart = () => {
      const {
        chartData,
        image,
        height,
        sliceColors,
        onHover,
        innerRadius,
        legend,
        labels,
        outerMargin,
        elementId,
      } = this.props

      const chartOptions = {
        container: document.getElementById(elementId),
        data: {
          preloaded: chartData,
        },
        events: {
          onHoverChange: onHover,
        },
        area: {
          height,
          // minWidth: 100,
          style: {
            image,
          },
        },
        interaction: {
          mode: 'drilldown',
          resizing: {
            enabled: false,
          },
        },
        pie: {
          innerRadius: innerRadius,
          outerMargin,
          style: {
            sliceColors: sliceColors,
            colorDistribution: 'list',
          },
        },
        labels: {
          enabled: labels,
        },
        legend: {
          enabled: legend,
          equalizeRowsColumns: true,
          height: 200,
          panel: {
            side: 'bottom',
            align: 'left',
          },
          showOthers: true,
          marker: {
            size: 15,
            shape: 'circle',
            lineColor: '#fff',
          },
          lineSpacing: 0,
          padding: 2,
          text: { font: '12px Open Sans' },
        },
        advanced: {
          backAlwaysVisible: true,
        },
        slice: {
          styleFunction: slice => {
            slice.label.text = `${capitalize(slice.data.name)} - ${this.formatData(slice)}%`
            slice.textStyle = { font: '12px Open Sans' }
          },
        },
      }

      return new window.PieChart(chartOptions)
    }
  }

  componentDidMount() {
    this._isMounted = true
    setTimeout(() => {
      if (this._isMounted) this.constructChart()
    }, 100)
  }

  componentDidUpdate(nextProps) {
    this._isMounted = true
    if (nextProps.shouldUpdateData && nextProps.chartData !== this.props.chartData) {
      setTimeout(() => {
        if (this._isMounted) this.constructChart()
      }, 100)
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  render() {
    const { elementId } = this.props
    return <div id={elementId} />
  }
}

export default CustomPieZoomChart



// WEBPACK FOOTER //
// ./src/components/ui/charts/zoom/CustomPieZoomChart.js